import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";

import Card from "../../../component/card/Card";
import TopInput from "./TopInput";
import { hrActions } from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import ReimbursementList from "./ReimbursementList";
import { tableHeader } from "./reimbursementData";
import useSortableData from "../../../customHooks/sortingHooks";
import Span from "../../../component/smallComponents/Span";
import { handleReimbursement } from "../../../redux/actions/hrActions";
import Starter from "../../../component/Starter";

const AllReimbursement = () => {
  const dispatch = useDispatch();

  const loginType = localStorage.loginType;
  const locationID = localStorage.locationId;

  const [allLocations, setAllLocations] = useState([]);
  const [allReimbursement, setAllReimbursement] = useState([]);

  const [values, setValues] = useState({
    date: "",
    locationId: ""
  });

  const { currentUser } = useSelector((state) => state.auth);
  const {
    hrResponse,
    hrError,
    hrLoading,
    reimbursementList,
    reimbursementGetDate,
    reimbursementTypeId
  } = useSelector((state) => state.hr);

  const { locations } = useSelector((state) => state.location);

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    setValues({
      date: reimbursementGetDate,
      locationId: reimbursementTypeId
    });
  }, [reimbursementGetDate, reimbursementTypeId]);

  useEffect(() => {
    if (reimbursementList !== null) {
      setAllReimbursement(reimbursementList);
    } else {
      setAllReimbursement([]);
    }
  }, [reimbursementList]);

  // on submit
  const onSubmit = (e) => {
    e.preventDefault();
    const date = new Date(values.date);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const reimbursementType = "byLocation";
    // console.log(date, month, year, reimbursementType, values);
    if (
      currentUser.workerDepartment === "SUPER ADMIN" &&
      currentUser.workerDesignation === "SUPER ADMIN"
    ) {
      dispatch(hrActions.setHrLoading(true));
      dispatch(hrActions.clearHrErrors());
      dispatch(hrActions.clearHrResult());
      const typeId = values.locationId;
      dispatch(
        hrActions.getReimbursement(
          month,
          year,
          typeId,
          reimbursementType,
          loginType,
          values.date
        )
      );
    } else {
      dispatch(
        hrActions.getReimbursement(
          month,
          year,
          locationID,
          reimbursementType,
          loginType,
          values.date
        )
      );
    }
  };

  const onChangeReimbursementStatus = (reimbursementDetails) => {
    const details = {
      reimbursementId: reimbursementDetails._id,
      status: reimbursementDetails.status
    };
    dispatch(handleReimbursement(details, loginType));
  };

  const changeSelectedStatus = (e, reimbursementId) => {
    const { value } = e.target;
    setAllReimbursement(
      allReimbursement.map((clickUser) => {
        if (clickUser._id === reimbursementId) {
          clickUser.status = value;
        }
        return clickUser;
      })
    );
  };

  const { items, requestSort, sortConfig } = useSortableData(
    allReimbursement
  );
  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const tableHeaderUi = () => {
    return tableHeader.map((header, index) => (
      <th
        data-tip
        data-for={header.type}
        key={index}
        className="text-center"
      >
        <Span
          label={header.label}
          type={header.type}
          requestSort={requestSort}
          getClassNamesFor={getClassNamesFor}
        />
        <ReactTooltip
          id={header.type}
          place="top"
          effect="solid"
          type="info"
        >
          {header.toolTipText}
        </ReactTooltip>
      </th>
    ));
  };

  return (
    <Starter
      topBarTitle="All Reimbursement"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">
            All Reimbursement
          </li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          onSubmit={onSubmit}
          loading={hrLoading}
          currentUser={currentUser}
          allLocations={allLocations}
          onChange={handleInputChange}
        />
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <th>From Date</th>
                <th>To Date</th>
                {tableHeaderUi()}
                <th>Status</th>
                <th>Actions</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ReimbursementList
                allReimbursement={items}
                hrLoading={hrLoading}
                changeSelectedStatus={changeSelectedStatus}
                onChangeReimbursementStatus={
                  onChangeReimbursementStatus
                }
              />
            </tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default AllReimbursement;
